import { render, staticRenderFns } from "./vetClientUserOrgSelecter.vue?vue&type=template&id=28a27612&"
import script from "./vetClientUserOrgSelecter.vue?vue&type=script&lang=js&"
export * from "./vetClientUserOrgSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports